import { Typography } from 'antd';
import styled from 'styled-components';
const { Text } = Typography;

export const StyledText = styled(Text)`
  color: ${(props) => props.color};
`;
